import { BadgeCheck, Boxes, FileText, GitBranch } from "lucide-react";
import { NodeCard, WORKLOAD_NAME } from "./internals";

export function DemonstrateVisual() {
  return (
    <div className="grid min-h-[220px] items-center gap-4 sm:min-h-[260px] sm:grid-cols-[1fr_1.05fr] sm:gap-5">
      <div className="rounded-lg border border-dashed border-primary/35 bg-primary-tint/25 p-4 sm:p-5">
        <p className="mb-3 font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary sm:mb-4">
          Evidence source
        </p>
        <div className="grid gap-3">
          <NodeCard icon={Boxes} title={WORKLOAD_NAME} detail="current workload state" tone="accent" />
          <NodeCard icon={GitBranch} title="Change history" detail="baseline + drift" />
        </div>
      </div>
      <div className="rounded-lg border border-border bg-surface p-4 shadow-md sm:p-5">
        <p className="font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary">
          Audit-ready records
        </p>
        <div className="mt-5 grid gap-3">
          {["DPIA", "RoPA", "Review history", "Baseline record"].map((label) => (
            <div
              key={label}
              className="flex items-center justify-between rounded-md border border-border bg-background px-3 py-2 text-sm"
            >
              <span className="flex items-center gap-2 font-semibold text-foreground">
                <FileText className="size-4 text-foreground-muted" />
                {label}
              </span>
              <BadgeCheck className="size-4 text-primary" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
